import type { LayoutType } from 'types';
import type { TranslationName } from 'types/translator';
import type { TemplateFormsState } from '../index';
import { getUsedTabs, hasUniqueTabNames } from '../utils/nameUniqueness';

interface Payload {
  layoutType: LayoutType;
  tabId: string;
  title: TranslationName[];
}

export const renameTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, tabId, title } = payload;
  const tab = state[layoutType].tabs.find((t) => t.id === tabId);

  if (!tab) return;

  const visibleTabs = getUsedTabs(state[layoutType].tabs, state[layoutType].sections);

  if (!hasUniqueTabNames(visibleTabs, { titleTranslations: title }, tabId)) {
    throw new Error('tabExists');
  }

  tab.titleTranslations = title;
};
